<template>
  <div>
    <ul class="tags" style="list-style-type: none; margin: 0; padding: 0px">
      <template v-if="isDrag">
        <draggable
          v-model="vtags"
          class="dragarea"
          v-bind="{ handle: '.my-handle', filter: '.ignore-elements', animation: 150 }"
        >
          <tag-item
            v-for="(tag, index) in vtags"
            :key="'tag_' + index"
            v-model="vtags[index].text"
            class="item"
            :is-drag="isDrag"
            @onDelete="removeTag(index)"
            @onChange="updateTag(index, $event)"
            @tags-changed="$emit('tags-changed', vtags)"
          ></tag-item>

          <li
            v-if="max == 0 || max > vtags.length"
            slot="footer"
            style="display: inline-block; margin-bottom: 3px"
          >
            <a
              v-if="!isAdd"
              ref="addTagBtn"
              href="javascript:void(0);"
              style="margin: 0px 0px; display: block"
              class="btn-tag"
              @click="onClickAddBtn"
            >
              <em class="fas fa-plus" />
              {{ btnText }}
            </a>
            <template v-else>
              <multiselect
                v-if="combobox"
                v-model="newTag"
                :show-labels="false"
                :options="options"
                :taggable="true"
                :reset-after="true"
                :clear-on-select="true"
                :hide-selected="true"
                :internal-search="false"
                :loading="loading"
                @tag="addTag"
                @input="addTag"
                @search-change="onSearch"
              >
              </multiselect>
              <input
                v-else
                ref="addInput"
                v-model="newTag"
                type="text"
                :placeholder="placeholder"
                @blur="addNewTag"
                @keyup.enter="addNewTag"
              />
            </template>
          </li>
        </draggable>
      </template>
      <template v-else>
        <tag-item
          v-for="(tag, index) in vtags"
          :key="'tag_' + index"
          v-model="vtags[index].text"
          :is-drag="isDrag"
          class="item"
          @onDelete="removeTag(index)"
          @onChange="updateTag(index, $event)"
          @tags-changed="$emit('tags-changed', vtags)"
        ></tag-item>

        <li
          v-if="max == 0 || max > vtags.length"
          slot="footer"
          style="display: inline-block; margin-bottom: 3px; margin-right: 3px"
        >
          <a
            v-if="!isAdd"
            ref="addTagBtn"
            href="javascript:void(0);"
            style="margin: 0px 0px; display: block"
            class="btn-tag"
            @click="onClickAddBtn"
          >
            <em class="fas fa-plus" />
            {{ btnText }}
          </a>
          <input
            v-else
            ref="addInput"
            v-model="newTag"
            type="text"
            :placeholder="placeholder"
            @blur="addNewTag"
            @keyup.enter="addNewTag"
          />
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import draggable from 'vuedraggable'
import TagItem from './TagItem'
export default {
  components: {
    Multiselect,
    draggable,
    TagItem
  },
  props: {
    value: undefined,
    tags: undefined,
    combobox: {
      default: false
    },
    edit: {
      type: Boolean,
      default: false
    },
    itemOption: {},
    placeholder: {
      default: 'Type Message'
    },
    btnText: {
      default: 'Add'
    },
    max: {
      type: Number,
      default: 0
    },
    isDrag: {
      type: Boolean,
      default: true
    }
  },
  data: function () {
    return {
      isAdd: false,
      vtags: [],
      newTag: '',
      options: [],
      loading: false
    }
  },
  watch: {
    tags: function () {
      if (this.tags) {
        this.vtags = this.tags

        if (this.vtags.length == 0) {
          this.isAdd = false
        }
      }
    },
    vtags: function () {
      this.$emit('tags-changed', this.vtags)
    }
  },
  mounted: function () {
    this.options = this.itemOption || []
    if (this.tags) {
      this.vtags = this.tags.map((el) => {
        return {
          ...el,
          id: Math.floor(Math.random() * 100) + 1
        }
      })
    }
  },
  methods: {
    onSearch(event) {
      const vm = this
      vm.loading = true
      vm.$emit('onSearch', {
        event,
        onComplete(options = []) {
          vm.options = options
          vm.loading = false
        }
      })
    },
    addTag(newTag) {
      this.newTag = newTag
      this.addNewTag()
    },
    onClickAddBtn: function () {
      var vm = this
      vm.isAdd = true
      vm.$nextTick(function () {
        if (vm.$refs.addInput) {
          vm.$refs.addInput.focus()
        }
      })
    },
    pressEnter: function (e) {
      if (e.keyCode === 13) {
        this.addNewTag()
      }
    },
    addNewTag: function () {
      var vm = this
      var tags = vm.newTag.split(',')
      if (vm.noSpaceAndSpecial(vm.newTag) === '') {
        vm.newTag = ''
        vm.isAdd = false
        vm.$emit('before-adding-tag', {
          type: 'add',
          tag: {
            // status: 'add',
            text: '',
            isDuplicate: false
          },
          addTag: function (event) {},
          error: function () {
            vm.isError = true
          }
        })
        return false
      }

      var isDuplicate = tags.find(function (tag, index) {
        var _tag = vm.noSpaceAndSpecial(tag)
        if (_tag != '') {
          if (vm.vtags.map((t) => t.text).indexOf(_tag) !== -1) {
            return true
          } else {
            return false
          }
        } else return false
      })

      tags.forEach((tag) => {
        vm.$emit('before-adding-tag', {
          type: 'add',
          tag: {
            // status: 'add',
            text: vm.noSpaceAndSpecial(tag),
            isDuplicate: isDuplicate
          },
          addTag: function (event) {
            vm.vtags.push({
              text: vm.noSpaceAndSpecial(tag),
              id: Math.floor(Math.random() * 100000) + 1
            })
            vm.$emit('tags-changed', vm.vtags)

            vm.newTag = ''
            vm.isAdd = false
            vm.$nextTick(function () {
              vm.$refs.addTagBtn.click()
            })
          },
          error: function () {
            vm.isError = true
          }
        })
      })
    },
    removeTag: function (index) {
      this.vtags.splice(index, 1)
      this.$emit('tags-changed', this.vtags)
    },
    updateTag: function (index, payload) {
      // console.log(payload)
      var vm = this
      var isDuplicate = false
      // console.log(vm.vtags.map(t => t.text).indexOf(payload.tag.text.trim()),index)
      if (
        vm.vtags.map((t) => t.text).indexOf(payload.tag.text.trim()) !== index &&
        vm.vtags.map((t) => t.text).indexOf(payload.tag.text.trim()) !== -1
      ) {
        isDuplicate = true
      } else {
        isDuplicate = false
      }
      payload.tag.isDuplicate = isDuplicate
      payload.type = 'edit'
      payload.index = index
      vm.$emit('before-adding-tag', payload)
    }
  }
}
</script>

<style lang="scss" scoped>
// $primary-color: var(--primary-color);

// .tags {

//     .tag-item {
//         border: 1px solid $primary-color;
//         background: $primary-color; // margin-top: 2px;
//     }

//     .btn-tag {
//         border: 1px solid $primary-color;
//         color: $primary-color;
//     }
// }

// ul.tags {

//     li.tag {
//         border: 1px solid $primary-color;
//         color: $primary-color;
//         &.active {
//             background: $primary-color;
//         }
//     }
// }
</style>



// WEBPACK FOOTER //
// src/components/elements/Tags.vue